import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./CheckIntoMeetingButton.module.css";
import checkMark from "./check-mark-svgrepo-com.svg";

/**
 * Interactive component checks you into meeting
 */
export function CheckIntoMeetingButton({ onClick, checkedIn }) {
  return (
    <>
      {checkedIn ? (
        <button
          className={classNames(styles.button, styles.checkedIn)}
        >
          <img src={checkMark} className={styles.checkMark} alt="Check Mark Icon"/>
          <span className={styles.checkedText}>You're Checked In!</span>
        </button>
      ) : (
        <button
          onClick={onClick}
          className={classNames(styles.button, styles.notCheckedIn)}
        >
          <span className={styles.notCheckedText}>Check In to Meeting!</span>
        </button>
      )}
    </>
  );
}

CheckIntoMeetingButton.propTypes = {
  onClick: PropTypes.func,
  checkedIn: PropTypes.bool,
};
